<!--Cases: 示范案例 2020/09/18 13:46:40 Sunanguang-->

<template>
   <div class="its-cases">
     <!--banner-->
     <banner :banners="banners"></banner>
     <!--main-->
     <ts-page-layout center>
       <div class="its-main">
         <case-item v-for="(c, index) in cases" :key="'case-' + index" :item="c" :class="index%3===0?'its-no-margin':''"></case-item>
         <case-item type="more"></case-item>
       </div>
     </ts-page-layout>
   </div>
</template>
<script>
import Banner from './components/Banner'
import CaseItem from './components/CaseItem'
export default {
  name: 'Cases',
  components: {
    Banner,
    CaseItem
  },
  data () {
    return {
      banners: [
        {
          key: 1,
          mainTitle: '精彩案例专区',
          subTitle: '寓教于乐 寓学于乐<br>践行信息化教育<br>e课堂与您同行',
          url: 'https://oss-ts-prod.oss-cn-hangzhou.aliyuncs.com/lecture/public/ued-video/ued-10.mp4',
          playCover: 'images/ued-cover-10.png'
        }
      ],
      cases: [
        {
          id: 1,
          title: '阳泉市第四中学校',
          desc: '教学设计与信息化技术高度融合的区域评估课展示',
          url: 'https://mp.weixin.qq.com/s?__biz=MzI0OTczNjgyMg==&mid=2247486215&idx=1&sn=8367c39c4a6501238f57362d28403ae4&chksm=e98db01edefa3908374c7e09021c32b53eb2d0efde9715b92322ed429031ef20f15094f3d291&token=1076210673&lang=zh_CN#rd'
        },
        {
          id: 2,
          title: '河北献县现代私立学校',
          desc: '创设现代化趣味课堂，让课堂教学更加美好',
          url: 'https://mp.weixin.qq.com/s?__biz=MzI0OTczNjgyMg==&mid=2247485977&idx=1&sn=6725bdde5ee7f5a0f9a178a60d8cb691&chksm=e98db100defa38164c052acd2fbafeb968bd0fb84902fe63c8005f16d933de87662a66fa6ba8&token=1076210673&lang=zh_CN#rd'
        },
        {
          id: 3,
          title: '韶关市浈江区实验学校',
          desc: '百余名师生智慧课堂试点班初体验',
          url: 'https://mp.weixin.qq.com/s?__biz=MzI0OTczNjgyMg==&mid=2247486197&idx=1&sn=20c1c107aec204fc02e8a4a6d062902d&chksm=e98db1ecdefa38fa08c4f66beb5ad2f93083c9f127d03c7156e00f84cdad116fa12cbeb7663e&token=1076210673&lang=zh_CN#rd'
        },
        {
          id: 4,
          title: '山西省沁县育英学校',
          desc: '践行信息化教学，让学生幸福感爆增',
          url: 'https://mp.weixin.qq.com/s?__biz=MzI0OTczNjgyMg==&mid=2247485737&idx=1&sn=dc284e0061c196065fdf4542ece27f0c&chksm=e98db230defa3b265ef85be7a1f62d21a7f324ff4232b80dcc83f2081f88419234666e0ad3e8&token=1076210673&lang=zh_CN#rd'
        },
        {
          id: 5,
          title: '河北迁西县奇石学校',
          desc: '大数据信息化教育，着眼学生个性化成长',
          url: 'https://mp.weixin.qq.com/s?__biz=MzI0OTczNjgyMg==&mid=2247485996&idx=1&sn=e7a90ce9093fec769f6de8f49f49cd46&chksm=e98db135defa38238d808baffa23439586ccedc6f726249805c95597e5c89e64ed5657695c83&token=917414955&lang=zh_CN#rd'
        },
        {
          id: 6,
          title: '宁夏盐池县第三中学',
          desc: '智慧指引教学，学习促进成长',
          url: 'https://mp.weixin.qq.com/s?__biz=MzI0OTczNjgyMg==&mid=2247486177&idx=1&sn=f673b1fdb9d1d12cce604c4478b7a671&chksm=e98db1f8defa38ee9b0b7e7a6ed866d4157e92249ba55249893d7c288db10403fd2120234be7&scene=178&cur_album_id=1619029654512664578#rd'
        },
        {
          id: 7,
          title: '广东省韶关市第八中学',
          desc: '教学方法变革引校领导班子高度重视',
          url: 'https://mp.weixin.qq.com/s?__biz=MzI0OTczNjgyMg==&mid=2247486157&idx=1&sn=4574e0d89855b4345e494480f6320fcb&chksm=e98db1d4defa38c2e8dde6e369a315461856fc359492ec9ddebb66b82f4c2f557c115e82c45d&token=1076210673&lang=zh_CN#rd'
        },
        {
          id: 8,
          title: '江西贵溪晨阳中学',
          desc: ' 打造智慧放“芯”现代化课堂  实现城乡教育资源共建共享',
          url: 'http://mp.weixin.qq.com/s?__biz=MzI0OTczNjgyMg==&mid=100002604&idx=1&sn=3d932bc126d22cce822cd00484a45083&chksm=698db0355efa39237c9c287265a5e76bdb05e6927d7ec67fcd2cdede4d24c8d6ab1e41cd4c04#rd'
        }
      ]
    }
  },
  mounted(){
      window.addEventListener('scroll', this.handleScroll)
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
  },
  destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
  },
  methods:{
    handleScroll: function(){
      this.$root.setHeaderBackground()
    }
  }
}
</script>
<style scoped>
.its-main {
  text-align: left;
  width: 1146px;
  margin: 97px auto 78px auto;
}

.its-no-margin {
  margin-left: 0 !important;
}
</style>